import { render, staticRenderFns } from "./Pipeline.vue?vue&type=template&id=4ff8b36d&scoped=true"
import script from "./Pipeline.vue?vue&type=script&lang=js"
export * from "./Pipeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff8b36d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff8b36d')) {
      api.createRecord('4ff8b36d', component.options)
    } else {
      api.reload('4ff8b36d', component.options)
    }
    module.hot.accept("./Pipeline.vue?vue&type=template&id=4ff8b36d&scoped=true", function () {
      api.rerender('4ff8b36d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/Pipeline.vue"
export default component.exports